import React, { useEffect } from 'react';
import LoadingScreen from 'react-loading-screen';
import { scrollTop } from 'utils/funciones';
import logo from '../assets/img/logo/logo-page.png';

/**
 *
 * @param {{children:any, message:string, loading:boolean}} param0
 * @returns
 */
const Loading = ({ children = '', message = 'Cargando...', loading = false }) => {
  useEffect(() => {
    scrollTop();
  }, [loading]);

  if (!loading) {
    return children;
  }

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#9ee5f8"
      textColor="#676767"
      logoSrc={logo}
      text={message}
    >
      {!loading && children}
    </LoadingScreen>
  );
};

export default Loading;
